"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SelectionBubble = function SelectionBubble(props) {
  var className = props.className,
      id = props.id,
      label = props.label,
      style = props.style,
      title = props.title,
      selected = props.selected,
      hideClose = props.hideClose;

  var selectionBubbleContainerClass = function selectionBubbleContainerClass() {
    return (0, _classnames["default"])({
      'ui-selection': true
    }, className);
  };

  var onClick = function onClick() {
    props.onClick(selected);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: selectionBubbleContainerClass(),
    style: style,
    title: title
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-selection__button-container"
  }, /*#__PURE__*/_react["default"].createElement("span", null, label), !hideClose && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: "button",
    className: "ui-selection__button",
    "aria-label": "'".concat(label, "'"),
    icon: "IconCross",
    size: 9,
    onClick: onClick
  })));
};

SelectionBubble.propTypes = {
  /** className for reference */
  className: _propTypes["default"].string,
  hideClose: _propTypes["default"].bool,

  /** id for reference */
  id: _propTypes["default"].string,

  /** label text for bubble */
  label: _propTypes["default"].string.isRequired,

  /** Callback function when the cross icon is clicked */
  onClick: _propTypes["default"].func.isRequired,

  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object,

  /** Selected object represented by bubble */
  selected: _propTypes["default"].object.isRequired,

  /** Message to display when hovering on the cross icon */
  title: _propTypes["default"].string
};
SelectionBubble.defaultProps = {
  id: '',
  className: '',
  style: {},
  title: '',
  hideClose: false
};
var _default = SelectionBubble;
exports["default"] = _default;